const branches = [
  "Computer Engineering",
  "Electronics and Telecommunication",
  "Electronics Engineering",
  "Mechatronics Engineering",
  "Instrumentation Engineering",
  "Information Technology",
  "Production Engineering",
  "Mechanical Engineering",
  "Electrical Engineering",
  "Chemical Engineering",
  "Civil Engineering",
  "Automobile Engineering",
  "Biotechnology Engineering",
  "Biomedical Engineering",
  "First Year Engineering",
  "Computer Engineering AIDS",
  "Electronics and Computer Science",
];

export default branches;